import React, { useState, useEffect, useContext } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import * as net from "../../../lib/net";
import Fr_Input from "../../../lib/ui/fr_input";
import Fr_Select from "../../../lib/ui/fr_select";

class Udid_open extends React.Component {
  constructor(props, context) {
    super(props);

    this.pos = props.store.pos;
    this.state = {};
    this.state.mka = [];
    this.state.sval = [];
    this.state.tval = [];
    this.state.paa = [];
    this.state.uaa = [];
    this.state.laa = [];

    this.state.sz_val = "";
      this.state.gnr = "001";
    //this.state.lro = props.lro;
    this.state.ynq = [
                {id: '0', text: 'NEJ'},
                {id: '1', text: 'JA'}
            ];

    this.state.cols = {};
    this.state.udo = {};
    if(props.wnds.udo) this.state.udo = props.wnds.udo;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    //this.btn_grps();
      if(!this.props.wnds.udo) this.udid_init();
  }

    udid_init() {
        var udo = {};
        udo.e1bastyp = "";
        udo.e1typ = "";
        udo.e1blank = "";
        udo.e1kontonr = "";
        udo.e1text = "";
        udo.e1debcre = "";
        udo.e1moms = "";
        udo.e1pris = "";
        udo.e1mattyp = "";
        udo.e1kassabal = "";
        udo.e1cancelled = "";
        udo.e1paytrans = "";
        udo.e1man_rep = "";
        udo.e1no_avail = "";
        //alert(JSON.stringify(rso));
        this.setState({ udo: udo });
        return;
    }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var pbo = this.state.pbo;
      var na = name.split(".");
      pbo[na[0]][na[1]] = value;
      this.setState({pbo: pbo});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
      if(this.props.close) {
          this.props.close(this.props.ctx);
      }
      else this.props.ctx.setState({ wnds: {} });
	};
    handleChange = (event, newValue) => {
        //alert(newValue);
        this.setState({ix: newValue});
      };
    toggle() {
      this.setState({modal: false});
	};

  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
  };

  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  val_save(id, val) {
      var eko = this.state.eko;
      eko[id] = val;
        this.setState({ eko: eko });
      return;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  cssCols (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
  udid_save() {
    var self = this;
    var prm = {};
    prm.req = "bcs.udid.udid_upd";
    prm.udo = this.state.udo;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok == "000") {
            self.setState({wnd_ok: true });
            setTimeout(function(){
                self.setState({wnd_ok: false });
                  if(self.props.close) {
                      self.props.close(self.props.ctx);
                  }
                  else self.props.ctx.setState({ wnd_rs: false });
                return;
            }, 1000);
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  udid_del() {
    var self = this;
    var prm = {};
    prm.req = "bcs.udid.udid_del";
    prm.udo = this.state.udo;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok == "000") {
            self.setState({wnd_ok: true });
            setTimeout(function(){
                self.setState({wnd_ok: false });
                  if(self.props.close) {
                      self.props.close(self.props.ctx);
                  }
                  else self.props.ctx.setState({ wnd_rs: false });
                return;
            }, 1000);
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    sz_keydown (e) {
        //e.preventDefault();
        const key = e.key;
        const keyCode = e.keyCode;

        if(keyCode == 13) {
            this.plu_sz();
        };
        if(keyCode == 27) {
            this.setState({sz_val: ""});
        };
    }
    sz_change (e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({sz_val: value});
        //setState({[name]: value});
    }

  render() {
    //if(!this.props.show) return "";
    var title = this.props.title;
    if(!title) title = "UDID";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        <div className="m2_backdrop" />
        <div className="m2_dlg mx_70 flex-col" style={ this.dlg_style() } >
        <div className="mx_top flex-row">

            <div className="">
                <div>UDID: { this.state.udo.udid }</div>
            </div>
            <div className="flex"></div>
            <div>UPPDATERA</div>
        </div>
            <div className="divider_orange"></div>

            <form className="cdi_f03">
            <div className="flex-row">
                    <Fr_Input label="Termnr" className="text-left w150" text={this.state.udo.termnr} getValue={(e)=> this.val_save("e1typ", e) } />
                    <Fr_Input label="Bastyp" className="text-left w150" text={this.state.udo.termtyp} getValue={(e)=> this.val_save("e1bastyp", e) } />
            </div>
            <div className="flex-row">
                    <Fr_Input label="Text" className="text-left w350" text={this.state.udo.text} getValue={(e)=> this.val_save("e1text", e) } />
                    <Fr_Input label="Konto" className="text-left w250" text={this.state.udo.e1kontonr} getValue={(e)=> this.val_save("e1kontonr", e) } />
            </div>
            <div className="flex-row">
                    <Fr_Input label="Pris" className="text-left w250" text={this.state.udo.e1pris} getValue={(e)=> this.val_save("e1pris", e) } />
            </div>
            </form>

            <div className="mx_section">

                <form className="cdi_f03">
                <div className="divider_green">Status</div>
                <div className="flex-row">
                    <Fr_Input label="Serial" className="text-left w250" text={this.state.udo.e1debcre} getValue={(e)=> this.val_save("e1debcre", e) } />
                    <Fr_Input label="Status" className="text-left w150" text={this.state.udo.e1moms} getValue={(e)=> this.val_save("e1moms", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Text" className="text-left w350" text={this.state.udo.e1kassabal} getValue={(e)=> this.val_save("e1kassabal", e) } />
                </div>

                <div className="divider_green">Status</div>
                <div className="flex-row">
                    <Fr_Input label="Serial" className="text-left w250" text={this.state.udo.e1debcre} getValue={(e)=> this.val_save("e1debcre", e) } />
                    <Fr_Input label="Status" className="text-left w150" text={this.state.udo.e1moms} getValue={(e)=> this.val_save("e1moms", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Text" className="text-left w350" text={this.state.udo.e1kassabal} getValue={(e)=> this.val_save("e1kassabal", e) } />
                </div>


                <div className="divider_green">Terminal</div>
                <div className="flex-row">
                    <Fr_Input label="Mattyp" className="text-left w250" text={this.state.udo.e1mattyp} getValue={(e)=> this.val_save("e1mattyp", e) } />
                    <Fr_Input label="Sortering" className="text-left w250" text={this.state.udo.e1sort} getValue={(e)=> this.val_save("e1sort", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Grupp" className="text-left w250" text={this.state.udo.e1grp} getValue={(e)=> this.val_save("e1grp", e) } />
                </div>

                <div className="divider_green">Terminal</div>
                <div className="flex-row">
                    <Fr_Input label="Mattyp" className="text-left w250" text={this.state.udo.e1mattyp} getValue={(e)=> this.val_save("e1mattyp", e) } />
                    <Fr_Input label="Sortering" className="text-left w250" text={this.state.udo.e1sort} getValue={(e)=> this.val_save("e1sort", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Grupp" className="text-left w250" text={this.state.udo.e1grp} getValue={(e)=> this.val_save("e1grp", e) } />
                </div>

                <div className="divider_green">TerminalX</div>
                <div className="flex-row">
                    <Fr_Input label="Mattyp" className="text-left w250" text={this.state.udo.e1mattyp} getValue={(e)=> this.val_save("e1mattyp", e) } />
                    <Fr_Input label="Sortering" className="text-left w250" text={this.state.udo.e1sort} getValue={(e)=> this.val_save("e1sort", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Grupp" className="text-left w250" text={this.state.udo.e1grp} getValue={(e)=> this.val_save("e1grp", e) } />
                </div>

                <div className="divider_green">TerminalY</div>
                <div className="flex-row">
                    <Fr_Input label="Mattyp" className="text-left w250" text={this.state.udo.e1mattyp} getValue={(e)=> this.val_save("e1mattyp", e) } />
                    <Fr_Input label="Sortering" className="text-left w250" text={this.state.udo.e1sort} getValue={(e)=> this.val_save("e1sort", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Grupp" className="text-left w250" text={this.state.udo.e1grp} getValue={(e)=> this.val_save("e1grp", e) } />
                </div>

                <div className="divider_green">TerminalZ</div>
                <div className="flex-row">
                    <Fr_Input label="Mattyp" className="text-left w250" text={this.state.udo.e1mattyp} getValue={(e)=> this.val_save("e1mattyp", e) } />
                    <Fr_Input label="Sortering" className="text-left w250" text={this.state.udo.e1sort} getValue={(e)=> this.val_save("e1sort", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Grupp" className="text-left w250" text={this.state.udo.e1grp} getValue={(e)=> this.val_save("e1grp", e) } />
                </div>

                </form>
            </div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <button className="btn btn-hw-red w250" onClick={() => this.udid_del() } >
                TA BORT
            </button>
            <div className="flex-row">
            <button className="btn btn-hw-red w250" onClick={() => this.udid_save() } >
                SPARA
            </button>
            </div>
        </div>
      </div>

      </div>
	;
	return html;
  };
}

export default Udid_open;